import React from 'react';
import { PropertyDetails } from '../../../core/api/models/project';
import { ShortlistedPropertiesListViewProps } from './shortListed-properties-list-view';
import { convertPascalCaseToWords, ProposalType, ProposedProperty } from '../../../core';
import Slider from 'react-slick';
import moment from 'moment';
import { FurnishingDetailsViewOption } from './props';

interface ShortlistedPropertiesDropdownTableProps {
    dropdownClick: (event: any, id: string, fieldName: string) => void;
    dropPos: { open: boolean; x: string; y: string; id: string; fieldName: string; } | undefined;
    excludeFloorPlanIds: any;
    excludeFurnishingIds: any;
    excludePhotoGalleryIds: any;
    floors: any[];
    handleFloorplanFurnishingChange: (propertyId: string, value: string) => void;
    handleThirdColumnChange: (projectId: string, checked: boolean) => void;
    item: any;
    onAllSelected: (selected: boolean, projectId: string) => void;
    onAllSelectedExcludeFloorPlan: (selected: boolean, projectId: string) => void;
    onAllSelectedExcludeFurnishing: (selected: boolean, projectId: string) => void;
    onAllSelectedExcludePhotoGallery: (selected: boolean, projectId: string) => void;
    onSelect: (sel: boolean, property: PropertyDetails) => void;
    onSelectExcludeFloorPlan: (sel: boolean, property: any) => void;
    onSelectExcludeFurnishing: (sel: boolean, property: any) => void;
    onSelectExcludePhotoGallery: (sel: boolean, property: any) => void;
    ordinalSuffixOf: (i: number) => string;
    proposedProperties: ProposedProperty[] | undefined;
    renderFieldDetails: (fieldName: string, fieldArrayValues: any) => JSX.Element;
    selectedFloorplanFurnishing: { [key: string]: string; } | undefined;
    selectedProperty: PropertyDetails[];
    setPropertyDetailModal: ShortlistedPropertiesListViewProps['setPropertyDetailModal'];
    showThirdColumn: { [key: string]: boolean; } | undefined;
    unitDetails: any;
}

const settings = {
    className: "require-slider",
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
};

export default function ShortlistedPropertiesDropdownTable({
    dropdownClick,
    dropPos,
    excludeFloorPlanIds,
    excludeFurnishingIds,
    excludePhotoGalleryIds,
    floors,
    handleFloorplanFurnishingChange,
    handleThirdColumnChange,
    item,
    onAllSelected,
    onAllSelectedExcludeFloorPlan,
    onAllSelectedExcludeFurnishing,
    onAllSelectedExcludePhotoGallery,
    onSelect,
    onSelectExcludeFloorPlan,
    onSelectExcludeFurnishing,
    onSelectExcludePhotoGallery,
    ordinalSuffixOf,
    proposedProperties,
    renderFieldDetails,
    selectedFloorplanFurnishing,
    selectedProperty,
    setPropertyDetailModal,
    showThirdColumn,
    unitDetails }: ShortlistedPropertiesDropdownTableProps) {

        const floorplanFurnishingOptions = [
            {
                name: convertPascalCaseToWords(FurnishingDetailsViewOption.TwoColumn),
                value: FurnishingDetailsViewOption.TwoColumn,
            },
            {
                name: convertPascalCaseToWords(FurnishingDetailsViewOption.SinglePage),
                value: FurnishingDetailsViewOption.SinglePage,
            },
            {
                name: convertPascalCaseToWords(FurnishingDetailsViewOption.ThreeColumn),
                value: FurnishingDetailsViewOption.ThreeColumn,
                disabled: true,
            },
        ];

    return (
        <>
            <div
                className="py-4 pr-4 pl-5"
                style={{ maxWidth: "80vw" }}
            >
                <Slider {...settings}>
                    <div className="border rounded p-2 d-inline-block mr-1 w-auto">
                        <div className="font-sm font-weight-semibold title">
                            Matching Unit
                        </div>
                        <div className="font-xs font-weight-medium text-gray-700">
                            {
                                unitDetails?.filter(
                                    (p: any) =>
                                        p.propertyDetailsFromProject
                                            .currentStatus ===
                                        "available"
                                )?.length
                            }{" "}
                            Available, {unitDetails?.length}{" "}
                            Total
                        </div>
                    </div>
                    {floors?.map((fl) => {
                        const availableCount = unitDetails?.filter(
                            (x: any) =>
                                x.propertyDetailsFromProject
                                    .currentStatus ===
                                "available" &&
                                x.propertyDetailsFromProject
                                    .floor === fl
                        )?.length;
                        const totalCount = unitDetails?.filter(
                            (x: any) =>
                                x.propertyDetailsFromProject
                                    .floor === fl
                        )?.length;

                        return (
                            <>
                                <div className="border rounded p-2 d-inline-block mr-1 w-auto">
                                    {fl === "0" ? (
                                        <div className="font-sm font-weight-semibold title">
                                            Ground Floor
                                        </div>
                                    ) : (
                                        <div className="font-sm font-weight-semibold title">
                                            {ordinalSuffixOf(
                                                Number(fl)
                                            )}{" "}
                                            Floor
                                        </div>
                                    )}
                                    <div className="font-xs font-weight-medium text-gray-700">
                                        {availableCount} Available,{" "}
                                        {totalCount} Total
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </Slider>
            </div>
            <div>
                <table className="table table-bordered w-100 font-sm">
                    <tr>
                        <td
                            className="py-2  px-2   border-bottom px-1"
                            style={{
                                maxWidth: "40px",
                                width: "40px",
                            }}
                        >
                            <div className="">
                                <input
                                    type="checkbox"
                                    name={`propertyCheck-unit-2-${item?.propertyDetailsFromProject?.projectId}`}
                                    id={`propertyCheck-px-2-${item?.propertyDetailsFromProject?.projectId}`}
                                    onChange={(e) =>
                                        onAllSelected(
                                            e.target.checked,
                                            item
                                                ?.propertyDetailsFromProject
                                                ?.projectId
                                        )
                                    }
                                    checked={
                                        selectedProperty?.filter(
                                            (ff) =>
                                                ff.projectId ===
                                                item
                                                    ?.propertyDetailsFromProject
                                                    ?.projectId
                                        )?.length ===
                                        unitDetails?.length
                                    }
                                />
                                <label
                                    htmlFor={`propertyCheck-px-2-${item?.propertyDetailsFromProject?.projectId}`}
                                ></label>
                            </div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">Floor</div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">Unit Id</div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">
                                Area (in Sq.Ft)
                            </div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">
                                Interior Type
                            </div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">
                                Quoted Rent
                            </div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">
                                Current Status
                            </div>
                        </td>
                        <td className="py-2 border-bottom">
                            <div className="py-1">
                                Available From
                            </div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">
                                Contact Details
                            </div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="d-flex align-items-center">
                                <div className="">
                                    <input
                                        type="checkbox"
                                        name={`excludeFlrCheck${item?.propertyDetailsFromProject?.projectId}`}
                                        id={`excludeFlrCheck-px-2-${item?.propertyDetailsFromProject?.projectId}`}
                                        onChange={(e) =>
                                            onAllSelectedExcludeFloorPlan(
                                                e.target.checked,
                                                item
                                                    ?.propertyDetailsFromProject
                                                    ?.projectId
                                            )
                                        }
                                        checked={
                                            excludeFloorPlanIds?.filter(
                                                (ff: any) =>
                                                    ff.projectId ===
                                                    item
                                                        ?.propertyDetailsFromProject
                                                        ?.projectId
                                            )?.length ===
                                            unitDetails?.length
                                        }
                                        disabled={
                                            !(
                                                selectedProperty?.filter(
                                                    (ff) =>
                                                        ff.projectId ===
                                                        item
                                                            ?.propertyDetailsFromProject
                                                            ?.projectId
                                                )?.length ===
                                                unitDetails?.length
                                            )
                                        }
                                    />
                                    <label
                                        htmlFor={`excludeFlrCheck-px-2-${item?.propertyDetailsFromProject?.projectId}`}
                                    ></label>
                                </div>
                                <div className="py-1">
                                    Exclude Floor Plan
                                </div>
                            </div>
                        </td>

                        <td className="py-2 border-bottom">
                            <div className="d-flex align-items-center">
                                <div className="">
                                    <input
                                        type="checkbox"
                                        name={`excludePhotoCheck${item?.propertyDetailsFromProject?.projectId}`}
                                        id={`excludePhotoCheck-px-2-${item?.propertyDetailsFromProject?.projectId}`}
                                        onChange={(e) =>
                                            onAllSelectedExcludePhotoGallery(
                                                e.target.checked,
                                                item
                                                    ?.propertyDetailsFromProject
                                                    ?.projectId
                                            )
                                        }
                                        checked={
                                            excludePhotoGalleryIds?.filter(
                                                (ff: any) =>
                                                    ff.projectId ===
                                                    item
                                                        ?.propertyDetailsFromProject
                                                        ?.projectId
                                            )?.length ===
                                            unitDetails?.length
                                        }
                                        disabled={
                                            !(
                                                selectedProperty?.filter(
                                                    (ff) =>
                                                        ff.projectId ===
                                                        item
                                                            ?.propertyDetailsFromProject
                                                            ?.projectId
                                                )?.length ===
                                                unitDetails?.length
                                            )
                                        }
                                    />
                                    <label
                                        htmlFor={`excludePhotoCheck-px-2-${item?.propertyDetailsFromProject?.projectId}`}
                                    ></label>
                                </div>
                                <div className="py-1">
                                    Exclude Photo Gallery
                                </div>
                            </div>
                        </td>

                        <td className="py-2 border-bottom font-sm">
                            <div className="d-flex align-items-center">
                                <div className="">
                                    <input
                                        type="checkbox"
                                        name={`excludeFurnishingCheck-${item?.propertyDetailsFromProject?.projectId}`}
                                        id={`excludeFurnishingCheck-${item?.propertyDetailsFromProject?.projectId}`}
                                        onChange={(e) =>
                                            onAllSelectedExcludeFurnishing(
                                                e.target.checked,
                                                item
                                                    ?.propertyDetailsFromProject
                                                    ?.projectId
                                            )
                                        }
                                        checked={
                                            excludeFurnishingIds?.filter(
                                                (ff: any) =>
                                                    ff.projectId ===
                                                    item
                                                        ?.propertyDetailsFromProject
                                                        ?.projectId
                                            )?.length ===
                                            unitDetails?.length
                                        }
                                    />
                                    <label
                                        htmlFor={`excludeFurnishingCheck-${item?.propertyDetailsFromProject?.projectId}`}
                                    ></label>
                                </div>
                                <div className="py-1">
                                    Exclude Furnishing
                                </div>
                            </div>
                        </td>

                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">
                                Floorplan & Furnishing Details
                                <div className="mt-1">
                                    <input
                                        type="checkbox"
                                        id={`showThirdColumn-${item.propertyDetailsFromProject?.projectId}`}
                                        checked={
                                            showThirdColumn?.[
                                            item
                                                .propertyDetailsFromProject
                                                ?.projectId
                                            ] || false
                                        }
                                        onChange={(e) =>
                                            handleThirdColumnChange(
                                                item
                                                    .propertyDetailsFromProject
                                                    ?.projectId,
                                                e.target.checked
                                            )
                                        }
                                        disabled={
                                            !!!selectedProperty?.find(
                                                (fv) =>
                                                    fv?.projectId ===
                                                    item
                                                        ?.propertyDetailsFromProject
                                                        ?.projectId
                                            )
                                        }
                                    />
                                    <label
                                        htmlFor={`showThirdColumn-${item.propertyDetailsFromProject?.projectId}`}
                                        className="font-sm pt-2px"
                                    >
                                        Three columns per page
                                    </label>
                                </div>
                            </div>
                        </td>
                    </tr>
                    {unitDetails?.map((unit: any) => {
                        const propertyDetails =
                            unit?.propertyDetails;

                        const property =
                            unit?.propertyDetailsFromProject;

                        const isUnitApproved = !!proposedProperties?.find(
                            (x) =>
                                x.propertyDetails?._id ===
                                item?.propertyDetailsFromProject
                                    ?.propertyId &&
                                x?.proposalType ===
                                ProposalType.Approved
                        );
                        const isUnitSent =
                            !isUnitApproved &&
                            !!proposedProperties?.find(
                                (x) =>
                                    x.propertyDetails?._id ===
                                    item
                                        .propertyDetailsFromProject
                                        ?.propertyId &&
                                    x?.proposalType ===
                                    ProposalType.Sent
                            );
                        const isUnitDraft =
                            !isUnitApproved &&
                            !isUnitSent &&
                            !!proposedProperties?.find(
                                (x) =>
                                    x.propertyDetails?._id ===
                                    item
                                        .propertyDetailsFromProject
                                        ?.propertyId &&
                                    x?.proposalType ===
                                    ProposalType.Draft
                            );

                        const isUnitRejected =
                            !isUnitApproved &&
                            !isUnitSent &&
                            !isUnitDraft &&
                            !!proposedProperties?.find(
                                (x) =>
                                    x.propertyDetails?._id ===
                                    item
                                        .propertyDetailsFromProject
                                        ?.propertyId &&
                                    x?.proposalType ===
                                    ProposalType.Rejected
                            );

                        return (
                            <>
                                <tr
                                    role="button"
                                    onClick={() => {
                                        if (property?.currentStatus === "available") {
                                            setPropertyDetailModal({
                                                isOpen: true,
                                                propertyId: property.propertyId,
                                            })
                                        }
                                    }}
                                >
                                    <td
                                        className="py-3 px-2 border-bottom px-0"
                                        style={{
                                            maxWidth: "40px",
                                            width: "40px",
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="">
                                            <input
                                                type="checkbox"
                                                name={`propertyCheck-${unit.projectId}-${property?.propertyId}`}
                                                id={`propertyCheck-${unit.projectId}-${property?.propertyId}`}
                                                onChange={(e) =>
                                                    onSelect(
                                                        e.target.checked,
                                                        {
                                                            ...property,
                                                            propertyDetails,
                                                            latitude:
                                                                unit
                                                                    ?.propertyDetails
                                                                    ?.proLatitude,
                                                            longitude:
                                                                unit
                                                                    ?.propertyDetails
                                                                    ?.proLongitude,
                                                            cityName:
                                                                unit
                                                                    ?.propertyDetails
                                                                    ?.cityName,
                                                            cityLocName:
                                                                unit
                                                                    ?.propertyDetails
                                                                    ?.cityLocName,
                                                        }
                                                    )
                                                }
                                                checked={
                                                    !!selectedProperty?.find(
                                                        (fv) =>
                                                            fv.propertyId ===
                                                            property?.propertyId
                                                    )
                                                }
                                            />
                                            <label
                                                htmlFor={`propertyCheck-${unit.projectId}-${property?.propertyId}`}
                                            ></label>
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {property.floor}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {property.unitName}
                                        </div>
                                        {isUnitApproved && (
                                            <span className="tag--approved font-xxs">
                                                Approved
                                            </span>
                                        )}
                                        {isUnitSent && (
                                            <span className="tag--active font-xxs">
                                                Proposed
                                            </span>
                                        )}
                                        {isUnitDraft && (
                                            <span className="tag--adminreviewrequested font-xxs">
                                                Requested
                                            </span>
                                        )}

                                        {isUnitRejected && (
                                            <span className="tag--adminrejected font-xxs">
                                                Rejected
                                            </span>
                                        )}
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {property.area?.toFixed(2)}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {property?.interiorType}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {property?.quotedRent}{" "}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {convertPascalCaseToWords(
                                                property?.currentStatus
                                            )}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        {property?.availableFrom &&
                                            property?.availableFrom !==
                                            "1970-01-01T00:00:00.000Z" && (
                                                <div className="">
                                                    {moment(
                                                        property?.availableFrom
                                                    ).format("DD-MM-YYYY")}
                                                </div>
                                            )}
                                    </td>
                                    <td
                                        className="py-2 border-bottom"
                                        style={{
                                            width: "290px",
                                            maxWidth: "290px",
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div
                                            role="button"
                                            className="py-1 w-100 font-xs font-weight-semibold position-relative"
                                            onClick={(e) =>
                                                dropdownClick(
                                                    e,
                                                    propertyDetails?._id,
                                                    "ContactDetails"
                                                )
                                            }
                                        >
                                            {propertyDetails
                                                ?.contactDetails?.length
                                                ? propertyDetails
                                                    ?.contactDetails
                                                    ?.length > 2
                                                    ? propertyDetails.contactDetails
                                                        .slice(0, 2)
                                                        .map(
                                                            (
                                                                participant: any
                                                            ) =>
                                                                participant
                                                                    ? `${participant.contactName ||
                                                                    ""
                                                                    }`
                                                                    : ""
                                                        )
                                                        .join(", ")
                                                    : propertyDetails?.contactDetails
                                                        ?.map(
                                                            (
                                                                participant: any
                                                            ) =>
                                                                participant
                                                                    ? `${participant.contactName ||
                                                                    ""
                                                                    }`
                                                                    : ""
                                                        )
                                                        .join(", ")
                                                : ""}
                                            <span className="text-primary cursor-pointer ">
                                                {propertyDetails
                                                    ?.contactDetails
                                                    ?.length > 2
                                                    ? ` +${propertyDetails
                                                        ?.contactDetails
                                                        ?.length - 2
                                                    }`
                                                    : ""}
                                                {propertyDetails._id ===
                                                    dropPos?.id &&
                                                    dropPos?.fieldName ===
                                                    "ContactDetails" &&
                                                    dropPos?.open &&
                                                    renderFieldDetails(
                                                        "Contact Details",
                                                        propertyDetails?.contactDetails
                                                    )}
                                            </span>
                                        </div>
                                    </td>

                                    {/* exclude start */}
                                    <td
                                        className="py-3 px-2 text-center border-bottom px-0"
                                        style={{
                                            maxWidth: "40px",
                                            width: "40px",
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="">
                                            <input
                                                type="checkbox"
                                                name={`excludeFlrCheck-${propertyDetails?._id}`}
                                                id={`excludeFlrCheck-${propertyDetails?._id}`}
                                                onChange={(e) =>
                                                    onSelectExcludeFloorPlan(
                                                        e.target.checked,
                                                        {
                                                            ...property,
                                                            propertyDetails,
                                                        }
                                                    )
                                                }
                                                checked={
                                                    !!excludeFloorPlanIds?.find(
                                                        (fv: {
                                                            propertyId: any;
                                                        }) =>
                                                            fv.propertyId ===
                                                            property?.propertyId
                                                    )
                                                }
                                                disabled={
                                                    !!!selectedProperty?.find(
                                                        (fv) =>
                                                            fv.propertyId ===
                                                            property?.propertyId
                                                    )
                                                }
                                            />
                                            <label
                                                htmlFor={`excludeFlrCheck-${propertyDetails?._id}`}
                                            ></label>
                                        </div>
                                    </td>

                                    {/* exclude end */}

                                    {/* exclude photo gallery start */}
                                    <td
                                        className="py-3 px-2 text-center border-bottom px-0"
                                        style={{
                                            maxWidth: "40px",
                                            width: "40px",
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="">
                                            <input
                                                type="checkbox"
                                                name={`excludePhotoCheck-${propertyDetails?._id}`}
                                                id={`excludePhotoCheck-${propertyDetails?._id}`}
                                                onChange={(e) =>
                                                    onSelectExcludePhotoGallery(
                                                        e.target.checked,
                                                        {
                                                            ...property,
                                                            propertyDetails,
                                                        }
                                                    )
                                                }
                                                checked={
                                                    !!excludePhotoGalleryIds?.find(
                                                        (fv: {
                                                            propertyId: any;
                                                        }) =>
                                                            fv.propertyId ===
                                                            property?.propertyId
                                                    )
                                                }
                                                disabled={
                                                    !!!selectedProperty?.find(
                                                        (fv) =>
                                                            fv.propertyId ===
                                                            property?.propertyId
                                                    )
                                                }
                                            />
                                            <label
                                                htmlFor={`excludePhotoCheck-${propertyDetails?._id}`}
                                            ></label>
                                        </div>
                                    </td>

                                    {/* exclude photo gallery end */}

                                    <td
                                        className="py-3 px-2 text-center border-bottom px-0"
                                        style={{
                                            maxWidth: "40px",
                                            width: "40px",
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="">
                                            <input
                                                type="checkbox"
                                                name={`excludeFurnishingCheck-${propertyDetails?._id}`}
                                                id={`excludeFurnishingCheck-${propertyDetails?._id}`}
                                                onChange={(e) =>
                                                    onSelectExcludeFurnishing(
                                                        e.target.checked,
                                                        {
                                                            ...property,
                                                            propertyDetails,
                                                        }
                                                    )
                                                }
                                                checked={
                                                    !!excludeFurnishingIds?.find(
                                                        (fv: {
                                                            propertyId: any;
                                                        }) =>
                                                            fv.propertyId ===
                                                            property?.propertyId
                                                    )
                                                }
                                                disabled={
                                                    !!!selectedProperty?.find(
                                                        (fv) =>
                                                            fv.propertyId ===
                                                            property?.propertyId
                                                    )
                                                }
                                            />
                                            <label
                                                htmlFor={`excludeFurnishingCheck-${propertyDetails?._id}`}
                                            ></label>
                                        </div>
                                    </td>

                                    <td className="py-3 border-bottom"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="py-1">
                                            <select
                                                className="form-control form-control-sm"
                                                value={selectedFloorplanFurnishing?.[
                                                    property?.propertyId
                                                ] || ""
                                                }
                                                onChange={(e) =>
                                                    handleFloorplanFurnishingChange(
                                                        property?.propertyId,
                                                        e.target.value
                                                    )
                                                }
                                                disabled={showThirdColumn?.[
                                                    property.projectId
                                                ] ||
                                                    !!!selectedProperty?.find(
                                                        (fv) =>
                                                            fv.propertyId ===
                                                            property?.propertyId
                                                    )
                                                }
                                            >
                                                {floorplanFurnishingOptions.map(
                                                    (option) => (
                                                        <option
                                                            key={option.value}
                                                            value={option.value}
                                                            disabled={
                                                                option.disabled
                                                            }
                                                        >
                                                            {option.name}
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                            </>
                        );
                    })}
                </table>
            </div>
        </>
    );
}
